import React, { ReactNode, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Input,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import Link from "next/link";

import { OpenAnyIDForm } from "~/components/OpenAnyIDForm";
import useApi from "~/hooks/use-api";

// TODO: Add some Zendesk stats - queue size, ave wait time, # new tickets

export default function DashboardPage() {
  return (
    <Container>
      <Row className="my-3">
        <Col>
          <h3>Dashboard</h3>
        </Col>
        <Col className="text-right">
          <OpenAnyIDForm goButton />
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg="9">
          <OrganizationsCard />
        </Col>

        <Col xs="12" md="6" lg="3">
          <HelpCard />
        </Col>
      </Row>
    </Container>
  );
}

const cardBodyStyle = {
  height: 300,
  overflow: "auto",
};

function HelpCard() {
  return (
    <>
      <Card>
        <CardHeader tag="h4">Get Help</CardHeader>
        <CardBody style={cardBodyStyle}>
          <ListGroup flush>
            <ListGroupItem
              tag="a"
              href="https://wiki.loke.global/doc/loke-glossary-eMkHF0Zi1B"
            >
              LOKE Glossary
            </ListGroupItem>
            <ListGroupItem
              tag="a"
              href="https://wiki.loke.global/collections/b3a2d72e-2aa0-4a7b-b667-de9cdef26155"
            >
              Product Documentation
            </ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </>
  );
}

interface Organization {
  uid: string;
  name: string;
  created: string;
  disabled: string;
}

function OrganizationsCard() {
  const { data: orgs } = useApi<Organization[]>("/api/organization", {
    revalidateOnFocus: false,
  });
  const recent = orgs
    ? [...orgs].sort((a, b) => (a.created < b.created ? 1 : -1))
    : [];

  return (
    <Card>
      <CardHeader tag="h4">Organisations</CardHeader>
      <CardBody>
        <OrganizationList orgs={recent} />
      </CardBody>
    </Card>
  );
}

function OrganizationList(props: { orgs: Organization[] }) {
  const [query, setQuery] = useState("");
  const orgs = (
    !query
      ? props.orgs
      : props.orgs.filter(
          (o) => o.name.toLowerCase().indexOf(query.toLowerCase()) >= 0
        )
  ).slice(0, 30);

  return (
    <>
      <Input
        placeholder="Filter..."
        onChange={(e) => setQuery(e.target.value)}
      />
      <ul>
        {orgs.map((o) => (
          <li key={o.uid}>
            <Link href="/orgs/[org]" as={"/orgs/" + o.uid}>
              <a>{o.name}</a>
            </Link>
          </li>
        ))}
        <style jsx>{`
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
          }
          li {
            padding-top: 5px;
            padding-bottom: 5px;
          }
        `}</style>
      </ul>
    </>
  );
}
